import { AreaItem } from '@/types/cms/AreaItem'
import styles from './TeaserHighlight_2.module.scss'
import React from 'react'
import TeaserHighlight from '@/elements/widgets/Teaser/Highlight/TeaserHighlight'
import { clsx } from 'clsx'

const TeaserHighlight_2 = ({ item }: { item: AreaItem }) => {
  return (
    <section className={clsx(styles.section, item?.model?.fields?.mobile && styles.mobile)}>
      {item?.items?.map((teaser: any, index: number) => {
        return (
          <TeaserHighlight item={teaser} key={index} options={item?.model?.fields}>
            <div className={styles['text-container']}>
              {teaser.model.kicker && (
                <div className={styles.kicker}>
                  <span>{teaser.model.kicker}</span>
                </div>
              )}
              <div className={styles.headline}>
                <span>{teaser.model.headline}</span>
              </div>
            </div>
          </TeaserHighlight>
        )
      })}
    </section>
  )
}

export default TeaserHighlight_2
